'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dPrepare$002dShopping$002dApp$002dPage from "./mealorama.-App-Router$-Prepare-Shopping-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$PrepareShoppingAppPage$() {
}
export { $c_Lmealorama_AppRouter$PrepareShoppingAppPage$ as $c_Lmealorama_AppRouter$PrepareShoppingAppPage$ };
$p = $c_Lmealorama_AppRouter$PrepareShoppingAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$PrepareShoppingAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$PrepareShoppingAppPage$() {
}
export { $h_Lmealorama_AppRouter$PrepareShoppingAppPage$ as $h_Lmealorama_AppRouter$PrepareShoppingAppPage$ };
$h_Lmealorama_AppRouter$PrepareShoppingAppPage$.prototype = $p;
$p.m = (function() {
  return "PrepareShoppingAppPage";
});
$p.aS5 = (function(x$0) {
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dPrepare$002dShopping$002dApp$002dPage.$c_Lmealorama_AppRouter$PrepareShoppingAppPage(x$0.g(0));
});
var $d_Lmealorama_AppRouter$PrepareShoppingAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$PrepareShoppingAppPage$, "mealorama.AppRouter$PrepareShoppingAppPage$", ({
  Fu: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$PrepareShoppingAppPage$ as $d_Lmealorama_AppRouter$PrepareShoppingAppPage$ };
var $n_Lmealorama_AppRouter$PrepareShoppingAppPage$;
function $m_Lmealorama_AppRouter$PrepareShoppingAppPage$() {
  if ((!$n_Lmealorama_AppRouter$PrepareShoppingAppPage$)) {
    $n_Lmealorama_AppRouter$PrepareShoppingAppPage$ = new $c_Lmealorama_AppRouter$PrepareShoppingAppPage$();
  }
  return $n_Lmealorama_AppRouter$PrepareShoppingAppPage$;
}
export { $m_Lmealorama_AppRouter$PrepareShoppingAppPage$ as $m_Lmealorama_AppRouter$PrepareShoppingAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Prepare-Shopping-App-Page$.js.map
